// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field[data-v-fff18eaa], .v-select[data-v-fff18eaa] {\n  padding-top: 0px;\n  margin-top: 4px;\n}", ""]);
// Exports
module.exports = exports;
